import { render, staticRenderFns } from "./BanksIntegrationsTip.vue?vue&type=template&id=618e8d36&"
import script from "./BanksIntegrationsTip.vue?vue&type=script&lang=js&"
export * from "./BanksIntegrationsTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports